"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowDownSolid = function ArrowDownSolid() {
  return _react2.default.createElement(
    "g",
    { id: "arrow_down", transform: "translate(0.000000, 110.000000)" },
    _react2.default.createElement("polygon", { id: "Polygon_2_copy_3", points: "250 312.5 0 0 500 0" })
  );
};

exports.default = ArrowDownSolid;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/ArrowDownSolid.js
// module id = 2921
// module chunks = 4